getWebContext = require './get-web-context'
logTracking = require './log-tracking'
trackGoogleTagManager = require './trackGoogleTagManager'

module.exports = (category, action, label, property, value) ->
  if typeof property == 'number'
    value = property
    property = undefined
  window.sp? 'trackStructEvent:anon', category, action, label, property, value, getWebContext()
  logTracking { category, action, label, property, value }




// WEBPACK FOOTER //
// ./app/scripts/debug/trackAnonymous.coffee